<template>
  <div v-if="question" class="flex flex-col gap-4">
    <rpm-input
        label="Nome da Questão"
        v-model="question.label"
        @blur="updateQuestion"
    ></rpm-input>

    <div class="grid grid-cols-[1fr_auto] gap-4">
      <rpm-input
          type="select"
          label="Input"
          v-model="question.field_type.id"
          :options="fieldTypes"
          optionLabel="label"
          optionValue="id"
      ></rpm-input>

      <rpm-input
          type="checkbox"
          v-model="question.required"
          @change="updateQuestion"
          core-class="h-full"
          wrapper-class="flex flex-row h-full justify-center items-center"
          label="Obrigatório"
      ></rpm-input>
    </div>

    <template v-if="question.field_type.label == 'text'">
      <rpm-input
          label="Máscara"
          placeholder="Máscara"
          @blur="updateQuestion"
          v-model="question.mask"
      ></rpm-input>
      <rpm-input
          label="Hint Placeholder"
          placeholder="Hint"
          @blur="updateQuestion"
          v-model="question.hint"
      ></rpm-input>
    </template>

    <template v-if="question.field_type.has_options">
      <rpm-draggable
          :list="question.options"
          v-slot="{ item: option }"
          class="flex flex-col gap-1"
      >
        <div
            class="flex flex-row items-center gap-2 px-2 border rounded border-gray-500/20 hover:border-theme/40 bg-white dark:bg-slate-700"
        >
          <i class="fa-solid fa-grip-lines"></i>
          <rpm-input
              no-border
              class="w-full"
              v-model="option.label"
              @blur="updateQuestionOption(option.id, option)"
          ></rpm-input>
          <rpm-button
              color-class="bg-transparent text-red-500 hover:text-red-600 focus:text-red-600"
              font-class="text-lg"
              icon="fa-solid fa-trash"
              tooltip-text="excluir opção"
              @click="deleteOption(option.id)"
          ></rpm-button>
        </div>
      </rpm-draggable>
    </template>

    <template v-if="question.field_type.has_options">
      <div class="flex flex-row items-center justify-center">
        <rpm-button
            icon="fa-solid fa-plus"
            class="px-2 py-1 rounded-md"
            font-class="text-sm"
            tooltip-text="adicionar opção"
            @click="addOption"
        ></rpm-button>
      </div>
    </template>

    <template v-if="question.field_type.label == 'file'">
      <rpm-input
          label="Formatos aceitos"
          type="multiselect"
          :options="[
          'pdf',
          'xls',
          'xlsx',
          'doc',
          'docx',
          'png',
          'jpg',
          'jpeg',
          'avi',
          'mpeg',
          'mp4'
        ]"
          v-model="question.mimes"
          @change="updateQuestion"
      ></rpm-input>

      <rpm-input
          v-if="hasImageMimes"
          type="checkbox"
          v-model="question.needs_coordinates"
          @change="handleCoordinatesChange" label="Coordenadas Geográficas"
      ></rpm-input>

      <rpm-input
          positive
          type="number"
          label="Quantidade Máxima"
          v-model="question.max"
          placeholder="Quantidade Máxima"
          @blur="updateQuestion"
      ></rpm-input>
    </template>
  </div>
</template>

<script>
import questionOptionRepository from "#repositories/questionOptionRepository";
import questionRepository from "#repositories/questionRepository";
import RpmDraggable from "#components/RpmDraggable.vue";
import _ from "lodash";

export default {
  name: "Question",
  components: {
    RpmDraggable,
  },
  data() {
    return {
      form: {
        id: null,
        label: null,
        hint: null,
        max: 0,
        min: 0,
        mask: null,
        order_number: 1,
        required: 1,
        enabled: true,
        allows_does_not_apply: false,
        field_type_id: null,
        mimes: [],
        options: [],
        needs_coordinates: false,
      },
    };
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
    fieldTypes: {
      type: [Array, Object],
    },
  },
  computed: {
    hasImageMimes() {
      if (!this.question.mimes || this.question.mimes.length === 0) {
        return false;
      }
      const imageMimes = ['png', 'jpg', 'jpeg'];
      return this.question.mimes.some(mime => imageMimes.includes(mime));
    }
  },
  methods: {
    async addOption() {
      let response = (
          await questionOptionRepository.storeQuestionOption({
            question_id: this.question.id,
            label: `Opção ${this.question.options.length + 1}`,
          })
      ).data;
      this.question.options.push(response);
    },
    updateQuestionOption(id, option) {
      let form = {
        ...option,
        question_id: this.question.id,
      };
      questionOptionRepository.updateQuestionOption(id, form).then(() => {
        this.$notify("", "success");
      });
    },
    async deleteOption(optionId) {
      await questionOptionRepository.deleteQuestionOption(optionId);
      this.question.options = this.question.options.filter(o => o.id !== optionId);
      this.$notify("Opção removida com sucesso", "success");
    },
    async handleCoordinatesChange() {
      await this.updateQuestion();
    },
    async updateQuestion() {
      await questionRepository.updateQuestion(this.question.id, this.question);
      this.$notify("Questão atualizada com sucesso", "success");
    },
  },
  watch: {
    "question.mimes": {
      handler(newMimes, oldMimes) {
        if (!this.hasImageMimes && this.question.needs_coordinates) {
          this.question.needs_coordinates = false;
          this.updateQuestion();
        }
      },
      deep: true
    },
    "question.field_type.id"(id) {
      this.question.field_type = _.cloneDeep(
          this.fieldTypes[
              this.fieldTypes.findIndex((ft) => {
                return ft.id == id;
              })
              ]
      );
      this.updateQuestion();
    },
  },
};
</script>
